import React, {useState,useEffect} from 'react';
import { useForm } from 'react-hook-form';
import clinicService from '../../../../../services/clinic.service';
import {toast} from 'react-toastify'

const ClinicOverviewForm = (props) => {
    const { register, handleSubmit, formState:{errors} } = useForm(
        {
            defaultValues: props.clinic
        }
    );
    const [clinic, setClinic] = useState(props.clinic);
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        setClinic(props.clinic);
    }, [props.clinic]);

    const onSubmit = (data) => {
        setIsLoading(true);
        //console.log(data);
        clinicService.updateClinic(clinic.id, data)
            .then(res => {
                setIsLoading(false);
                setIsSuccess(true);
                setIsError(false);
                setErrorMessage('');
                toast.success("Modified Successfully",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
               
            })
            .catch(err => {
                setIsLoading(false);
                setIsSuccess(false);
                setIsError(true);
                setErrorMessage(err.response.data.message);
                toast.error(err.response.data.message,{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
                
            });
    };
    return ( 
        <>
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Status:</div>
                   <div className="col-lg-9 col-md-8">
                           <select 
                                className="form-select"
                                {...register("status", {required:true})}
                           >
                                 <option value="1">Active</option>
                                 <option value="0">Inactive</option>
                           </select>
                           {errors.status && <span className="text-danger">Status is required</span>}
                   </div>
               </div>
            <div className="row mb-2">
                 <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Type:</div>
                 <div className="col-lg-9 col-md-8">
                 <select 
                                className="form-select"
                                {...register("clinicType", {required:true})}
                           >
                                 <option value="EYECONX">EYECONX</option>
                                 <option value="SMS_GATEWAY">SMS GATEWAY</option>
                                 <option value="ADMIN">ADMIN</option>
                           </select>
                </div>
            </div>
            <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Name:</div>
                   <div className="col-lg-9 col-md-8">
                          <input 
                            type="text" 
                            className="form-control" 
                            placeholder="Clinic Name" 
                            {...register("name", {required:true})}
                            />
                            {errors.name && <div className="text-danger">Name is required</div>}
                   </div>
                    
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Email:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic Email"
                                {...register("email", {required:true})}
                                />
                                {errors.email && <div className="text-danger">Email is required</div>}
                   </div>

                   
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Phone:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic Phone" 
                                {...register("phone", {required:true})}
                                />
                                {errors.phone && <div className="text-danger">Phone is required</div>}
                   </div>
                      
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>SMS:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic SMS"
                                {...register("sms", {required:true})}
                                />
                                {errors.sms && <div className="text-danger">SMS is required</div>}
                   </div>
                        
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Signature:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic Signature"
                                {...register("signature", {required:true})}
                                />
                            {errors.signature && <div className="text-danger">Signature is required</div>}
                   </div>
                     
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Logo:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic Logo"
                                {...register("logo")}
                                />
                           
                   </div>
                     
               </div>
               <div className="row mb-2">
                   <div className="col-lg-3 col-md-4 label" style={{fontWeight:"600",color:"rgba(1, 41, 112, 0.6)"}}>Website:</div>
                   <div className="col-lg-9 col-md-8">
                            <input 
                                type="text" 
                                className="form-control" 
                                placeholder="Clinic Website" 
                                {...register("website", {required:true})}
                                />
                            {errors.website && <div className="text-danger">Website is required</div>}
                   </div>
                       
               </div>
             
               <button  type="submit" className="btn btn-secondary">
                {isLoading?<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>:""}
                <i className="bi bi-check-square-fill"></i> Save
               </button>
            </form>
        </>
     );
}
 
export default ClinicOverviewForm;